import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';

import availableDateTimeOptions from '../available-date-time-options';
import { hasShift } from '../utils';
import './style.css';

const DayGrid = ({ value, onChange }) => {
  const arr = Object.values(value);

  return (
    <div className="days-grid-input">
      {availableDateTimeOptions.map((day) => {
        return (
          <React.Fragment key={`${day.value}-day`}>
            <h3>{day.label}</h3>
            {day.options.map((hour) => {
              const checked = hasShift(arr, hour.value);
              return (
                <Checkbox
                  onChange={onChange}
                  key={`${hour.value.day}-${hour.value.startTime}-${hour.value.endTime}`}
                  value={hour.value}
                  checked={checked}
                >
                  {hour.label}
                </Checkbox>
              );
            })}
          </React.Fragment>
        );
      })}
    </div>
  );
};

DayGrid.propTypes = {
  value: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DayGrid;
